// Shared quiz grading helpers used by the quiz flow and the leaderboard.

// Mood badge styles shared by the live ticket sim and the results view.
export const MOOD_BADGE = {
  friendly: "bg-emerald-100 text-emerald-700",
  neutral: "bg-slate-100 text-slate-600",
  aggressive: "bg-rose-100 text-rose-700"
};

// A ticket's mood arc is brushed randomly once per session.
export const TICKET_ARCS = ["friendly", "neutral", "aggressive", "stress"];

export function pickTicketArc() {
  return TICKET_ARCS[Math.floor(Math.random() * TICKET_ARCS.length)];
}

// Build the live sequence of customer turns for a ticket given its arc.
// Stable arcs keep one mood throughout; the "stress" arc starts neutral,
// snaps to aggressive, then throws an out-of-scope request and a mind-change.
export function buildTicketTurns(q, arc) {
  const turns = q.turns || [];
  if (arc === "stress") {
    const seq = [];
    if (turns[0])
      seq.push({ ...turns[0], mood: "neutral", message: turns[0].messages.neutral });
    if (turns[1])
      seq.push({ ...turns[1], mood: "aggressive", message: turns[1].messages.aggressive });
    if (turns[2])
      seq.push({ ...turns[2], mood: "aggressive", message: turns[2].messages.aggressive });
    (q.stressTurns || []).forEach((t) =>
      seq.push({ ...t, mood: "aggressive", message: t.message })
    );
    return seq;
  }
  return turns.map((t) => ({ ...t, mood: arc, message: t.messages[arc] }));
}

export function gradeQuestion(q, a) {
  if (q.type === "multiple_choice") return a === q.correctIndex;
  if (q.type === "true_false") return a === q.correctAnswer;
  if (q.type === "sequence") {
    return (
      Array.isArray(a) &&
      a.length === q.tiles.length &&
      a.every((v, i) => v === i)
    );
  }
  if (q.type === "compliance") {
    const errorIds = q.segments.filter((s) => s.error).map((s) => s.id);
    return (
      Array.isArray(a) &&
      errorIds.every((id) => a.includes(id)) &&
      a.every((id) => errorIds.includes(id))
    );
  }
  if (q.type === "ticket_simulation") {
    if (!a || !Array.isArray(a.picks)) return false;
    const turns = buildTicketTurns(q, a.arc);
    return (
      turns.length > 0 &&
      turns.length === a.picks.length &&
      turns.every((t, i) => a.picks[i] === t.correctIndex)
    );
  }
  return null; // scenario (not auto-graded)
}

export function computeScore(questions, answers) {
  const graded = questions.filter((q) => q.type !== "scenario");
  const correct = graded.filter((q) => gradeQuestion(q, answers[q.id])).length;
  const pct = graded.length ? Math.round((correct / graded.length) * 100) : 0;
  return { correct, total: graded.length, pct };
}